import React from 'react';
interface CalloutProps {
  variant?: 'key-fact' | 'science' | 'warning' | 'guarantee' | 'note';
  label?: string;
  title?: string;
  children: ReactNode;
}
export function Callout({
  variant = 'note',
  label,
  title,
  children
}: CalloutProps) {
  const getStyles = () => {
    switch (variant) {
      case 'key-fact':
        return 'bg-beige border-l-4 border-sage';
      case 'science':
        return 'bg-[#E8EDE9] border-l-4 border-forest';
      case 'warning':
        return 'bg-[#F5EBE6] border-l-4 border-[#A36B5D]';
      case 'guarantee':
        return 'bg-forest text-cream border-none shadow-lg';
      default:
        return 'bg-beige border-l-4 border-taupe';
    }
  };
  const getLabelColor = () => {
    if (variant === 'guarantee') return 'text-cream/70';
    if (variant === 'warning') return 'text-[#A36B5D]';
    return 'text-sage';
  };
  const getTitleColor = () => {
    if (variant === 'guarantee') return 'text-white';
    return 'text-forest';
  };
  return <div className={`rounded-2xl p-6 sm:p-8 my-10 ${getStyles()}`} data-id="element-114">
      {label && <span className={`block text-[11px] font-bold uppercase tracking-widest mb-3 ${getLabelColor()}`} data-id="element-115">
          {label}
        </span>}
      {title && <h3 className={`text-xl sm:text-2xl font-serif font-medium mb-4 ${getTitleColor()}`} data-id="element-116">
          {title}
        </h3>}
      <div className={`text-base sm:text-lg leading-relaxed ${variant === 'guarantee' ? 'text-cream/90' : 'text-ink/80'}`} data-id="element-117">
        {children}
      </div>
    </div>;
}